// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Loader_spinnerContainer__KdDRW","loadingTextHide":"Loader_loadingTextHide__oc3th"};